import {keywords} from './keywords';

export default (dgs,selectedGroups,lng)=>{
  
  const getColor = (name,key)=>{
    const array = selectedGroups[name];
    if(!array)return null;    
    console.log(array,key)
    return array.includes(key)?{}:{
      itemStyle: {
            color: '#999999'
          }
    };
  };
  const locale = new Intl.NumberFormat(lng=="en"?'en-US':"fr-FR");
  const columns = keywords.filter(o=>o.group=="dataColHeader").reduce((acc,o)=>({...acc,[o.key]:o[lng]}),{});
  // const substance =columns["SubstanceID"];
  // const boundary =columns["Boundary"];
  // const activity =columns["Activity"];
  // const sourceGroup =columns["SourceGroup"];
  // const sourceSubGroup =columns["SourceSubGroup"];
  // const substanceGroup =columns["SubstanceGroup"];
  // const equipment =columns["Equipment"];
// const amount = columns["Amount"];

  const substance ="SubstanceID";
  const boundary ="Boundary";
  const activity ="Activity";
  const sourceGroup ="SourceGroup";
  const sourceSubGroup ="SourceSubGroup";
  const substanceGroup ="SubstanceGroup";
  const equipment ="Equipment";
  const amount = "Amount";
  
  console.log("locale",locale)
  console.log("substanceGroup",substanceGroup)
  const getData=(_name,isLog=false)=>{
    
    if(isLog)return dgs.find(dg=>dg.name==_name)?.group.all().map(({key,value})=>({name:key,value:Math.max(value,1),...getColor(_name,key)}))
    return dgs.find(dg=>dg.name==_name)?.group.all().map(({key,value})=>({name:key,value,...getColor(_name,key)}))
  }
  const getMin=(_name)=>{
    return Math.min(...dgs.find(dg=>dg.name==_name)?.group.all().map(({key,value})=>value) ??[])
  }
  const getMax=(_name)=>{
    
    return Math.max(...dgs.find(dg=>dg.name==_name)?.group.all().map(({key,value})=>value) ??[])
  }
 
 
  
  const substanceOrder=lng=="en"?[
    "BC",
    "CH4",
    "CO2",
    "N2O",
    "CO",
    "DPM",
    "NH3",
    "NOx",
    "PM10",
    "PM2.5",
    "SOx",
    "VOC",
    "THC",
    "Fuel (GJ)",
    "Fuel (L)",
    "Fuel (kg)"
    ]:[
    "CN",
    "CH4",
    "CO2",
    "N2O",
    "CO",
    "MPD",
    "NH3",
    "NOx",
    "MP10",
    "MP2,5",
    "SOx",
    "COV",
    "HCt",
    "Carburant (GJ)",
    "Carburant (L)",
    "Carburant (kg)"
    ]

  
  return [
    {
      id:substanceGroup,
      name:substanceGroup,
      title:columns["SubstanceGroup"],
      dashboard:{},
      f:(d)=>d[amount],
      
      options:()=>({
        name:columns["SubstanceGroup"],
        // title: {
        //   text: 'Substance Group',
        //   x: 'center',
        // },
         grid: {
          left: '10%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c}',
          formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        },
        series: [
          {
            name: columns["SubstanceGroup"],
            type: 'pie',
            radius: '50%',
            data: getData(substanceGroup)
              
          },
        ],
      })
    },
    {
      id:substance,
      name:substance,
      title:columns["Substance"],
      f:(d)=>d[amount],
      
      options:()=>({
        name:substance,
        // title: {
        //   text: 'Substance',
        //   x: 'center',
        // },
        grid: {
          left: '20%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)',
          formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        },
         xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0, // Display all labels
          },
          // data: dgs.find(o=>o.name==substance)?.uniques,
          data: substanceOrder,
        },
         yAxis: {
            logBase: 2,
            type: 'log', // Set the y-axis scale to logarithmic                        
            min: 1,
            max: 'dataMax',
            axisLabel: {
              // formatter: (value)=>value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              formatter: (value) => locale.format(value.toFixed(0)),
            
            }
            
          // min: getMin(substance), // Set the minimum dynamically
          // max: "dataMax"  // Set the maximum dynamically
        },
        series: [
          {
            name: substance,
            type: 'bar',
            // radius: '50%',
            data: getData(substance,true).filter(o=>substanceOrder.indexOf(o.name)!=-1).sort((a,b)=>substanceOrder.indexOf(a.name) - substanceOrder.indexOf(b.name))
              
          },
        ],
      })
    },
    {
      id:boundary,
      name:boundary,
      title:columns["Boundary"],
      f:(d)=>d[amount],
      
      options:()=>({
        name:boundary,
        // title: {
        //   text: 'Boundary',
        //   x: 'center',
        // },
        grid: {
          left: '10%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)',
          formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        },
        series: [
          {
            name: boundary,
            type: 'pie',
            radius: '50%',
            data:  getData(boundary)
              
          },
        ],
      })
    },
    {
      id:activity,
      name:activity,
      title:columns["Activity"],
      f:(d)=>d[amount],
      
      options:()=>({
      // title: {
      //   text: 'Activity',
      //   x: 'center',
      // },
      tooltip: {
        trigger: 'item',
        formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
          left: '20%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
      xAxis: {
        type: 'category',
        axisLabel: {
          interval: 0, // Display all labels
        },
        data: dgs.find(o=>o.name==activity)?.uniques,
      },
      yAxis: {
        type: 'value',
         axisLabel: {
              
              formatter: (value) => locale.format(value.toFixed(0)),
            
            }
      },
      series: [
        {
          name: activity,
          type: 'bar',
          data: getData(activity)
        },
      ],
    })
    },
    {
      id:sourceGroup,
      name:sourceGroup,
      title:columns["SourceGroup"],
      f:(d)=>d[amount],
      
      options:()=>({
        name:sourceGroup,
        // title: {
        //   text: 'SourceGroup',
        //   x: 'center',
        // },
        grid: {
          left: '10%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)',
          formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        },
        series: [
          {
            name: sourceGroup,
            type: 'pie',
            radius: '50%',
            data: getData(sourceGroup)
              
          },
        ],
      })
    },
    {
      id:equipment,
      name:equipment,
      title:columns["Equipment"],
      f:(d)=>d[amount],
      
      options:()=>({
        name:equipment,
        // title: {
        //   text: 'SourceGroup',
        //   x: 'center',
        // },
        grid: {
          left: '10%', // Adjust the left padding
          right: '10%', // Adjust the right padding
          top: '10%', // Adjust the top padding
          bottom: '10%', // Adjust the bottom padding
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)',
          formatter:({name,value}) => `${name} <br/>${value.toFixed(0)}`,
        },
        series: [
          {
            name: equipment,
            type: 'pie',
            radius: '50%',
            data: getData(equipment)
              
          },
        ],
      })
    },
  ]
}